export default {
    props: {
        loadData: Object
    },
    watch: {
        formData: {
            deep: true,
            handler: function (data) {
                this.$emit('formData', data);
            }
        }
    }
}